<!-- 헤더 컨트롤 컴포넌트 -->
<template>
    <div class="header-controls">
        <button
            class="refresh-icon mr-2"
            :class="{ active: expanded }"
            @click="$emit('change-expanded-tree')"
            v-b-tooltip.hover
            :title="$t(expanded ? '트리 열기' : '트리 닫기')"
        >
            <i class="fas fa-columns" aria-hidden="true"></i>
        </button>

        <select v-model="localQueryType" class="form-control mr-2" style="width: 8rem" @change="handleQueryTypeChange">
            <option :value="null">선택</option>
            <option value="NOW">실시간</option>
            <option value="DAY">일간</option>
            <option value="MONTH">월간</option>
        </select>

        <date-picker
            v-model="localStatusDate"
            :type="localQueryType !== 'MONTH' ? 'date' : 'month'"
            :valueType="localQueryType !== 'MONTH' ? 'YYYY-MM-DD' : 'YYYY-MM'"
            :disabled="localQueryType === 'NOW' || localQueryType === null ? true : false"
            lang="ko"
            style="width: 8rem"
            class="status-date mr-2"
            @change="handleDateChange"
        ></date-picker>
        <button
            class="refresh-icon mr-2"
            @click="$emit('prev-day')"
            v-b-tooltip
            :disabled="localQueryType === 'NOW' || localQueryType === null"
            :title="localQueryType == 'NOW' || localQueryType == 'DAY' ? '이전 일 조회' : '이전 월 조회'"
        >
            <i class="fas fa-angle-left" aria-hidden="true"></i>
        </button>
        <button
            class="refresh-icon mr-2"
            @click="$emit('next-day')"
            v-b-tooltip
            :disabled="localQueryType === 'NOW' || localQueryType === null"
            :title="localQueryType == 'NOW' || localQueryType == 'DAY' ? '다음 일 조회' : '다음 월 조회'"
        >
            <i class="fas fa-angle-right" aria-hidden="true"></i>
        </button>
        <button
            class="refresh-icon mr-2"
            :class="{ active: isRefresh }"
            @click="$emit('interval-refresh')"
            v-b-tooltip.hover
            :title="isRefresh ? '자동 갱신 끄기' : '자동 갱신 켜기'"
        >
            <i class="fa fa-redo" aria-hidden="true"></i>
        </button>
        <button class="exportPdf" @click="$emit('export-pdf')">
            <i class="fas fa-file-pdf" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    name: "DetailHeaderControls",
    components: {
        DatePicker,
    },
    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
        queryType: {
            type: String,
            default: "NOW",
        },
        statusDate: {
            type: String,
            default: () => moment(new Date()).format("YYYY-MM-DD"),
        },
        isRefresh: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        "change-expanded-tree",
        "change-query-date",
        "change-date",
        "prev-day",
        "next-day",
        "interval-refresh",
        "export-pdf",
    ],
    data() {
        return {
            localQueryType: this.queryType,
            localStatusDate: this.statusDate,
        };
    },
    watch: {
        queryType(newVal) {
            this.localQueryType = newVal;
        },
        statusDate(newVal) {
            this.localStatusDate = newVal;
        },
    },
    methods: {
        handleQueryTypeChange() {
            this.$emit("change-query-date", this.localQueryType);
        },
        handleDateChange(date) {
            this.$emit("change-date", date);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../styles/common/_detail-buttons.scss";

.header-controls {
    display: flex;
    align-items: center;
}

.refresh-icon {
    color: #555;
    background-color: #fff;
    border: solid #bbb 1px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.2rem;
    transition: background-color 0.5s;
    width: 2rem;
    height: 2rem;
}

.refresh-icon:hover {
    background-color: #c7c7c7;
}

.refresh-icon.active {
    color: #fff;
    background-color: #555;
}

.refresh-icon:disabled,
.refresh-icon[disabled] {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #ccc;
    color: #666;
    border-color: #aaa;
}

.exportPdf {
    color: #dc3545;
    background-color: #fff;
    border: solid #dc3545 1px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.3s;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
}

.exportPdf:hover {
    background-color: #dc3545;
    color: #fff;
}

.exportPdf:focus {
    outline: none;
    /* border: none; */
}
</style>
